import throttle from 'lodash/throttle';
import React, { useCallback, useState } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';

import { useImpersonateMutation } from 'apollo/queries/autogenerate/hooks-public';
import Button from 'shared/modules/common/components/atoms/Button';
import TextInput from 'shared/modules/common/components/atoms/TextInput';

type Props = {
  token: string;
  onSuccess?: (sessionToken: string) => void;
};

const Impersonate = (props: Props) => {
  const [impersonateMutation] = useImpersonateMutation();
  const [password, setPassword] = useState('');
  const [isError, setIsError] = useState(false);

  const submit = useCallback(
    throttle(
      async () => {
        try {
          const session = await impersonateMutation({
            variables: {
              token: props.token,
              password,
            },
            context: {
              uri: process.env.CONSUMER_API_HOST_GRAPHQL_PUBLIC,
            },
          });

          props.onSuccess?.(session.data?.impersonate.sessionToken || '');
        } catch (err) {
          setIsError(true);
        }
      },
      2000,
      { leading: true, trailing: false }
    ),
    [password]
  );

  return (
    <View
      style={style.root}
      {...Platform.select({ web: { accessibilityRole: 'form' } })}
    >
      <View>
        <Text style={[style.text, style.title]}>
          パスワードを入力してください
        </Text>
        <TextInput
          placeholder="パスワードを入力してください"
          label="パスワード"
          onChangeText={setPassword}
          value={password}
          message={isError ? 'トークンが無効またはパスワードが違います' : ''}
          state={isError ? 'error' : undefined}
          secureTextEntry
          style={style.textInput}
          id="impersonate-password-field"
        />
      </View>
      <Button
        title="ログイン"
        onPress={submit}
        id="impersonate-submit-button"
      />
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-between',
  },
  text: {
    marginBottom: 8,
  },
  title: {
    fontWeight: 'bold',
  },
  textInput: {
    marginBottom: 24,
  },
});

export default Impersonate;
